import CardCrmSystem from "./CardCrmSystem";
import React from "react";
import {Col} from "reactstrap";
import {ICrmSystem} from "../../../store/crmSystems/types";

interface ListCrmSystemsProps {
    crmSystems: Array<ICrmSystem>
    onUpdate?: (id: number) => void
    onDelete?: (id: number) => void
}

const ListCrmSystems: React.FC<ListCrmSystemsProps> = ({crmSystems, onUpdate, onDelete}) => {
    return (
        <React.Fragment>
            {crmSystems.map(item => (
                <Col key={item.id} lg="4" md="6" sm="12">
                    <CardCrmSystem id={item.id} name={item.name} onUpdate={onUpdate} onDelete={onDelete}/>
                </Col>
            ))}
        </React.Fragment>
    )
}

export default ListCrmSystems;